import React from 'react';
import { FormattedMessage } from 'react-intl';
import { formatContentWithEmoji } from '../../alert';

const AutoPilotOn = (props) => {
  return (
    <div>
      <div className="modal-section modal-title text-center blue full">
        <h1>
          <FormattedMessage
            id="autoPilot.on.title"
            defaultMessage="Auto-pilot on"
          />
        </h1>
      </div>
      <div className="modal-section divider pb-5">
        <h3>
          <FormattedMessage
            id="autoPilot.on.whatWillHappen"
            defaultMessage="When the target you set is reached,
              we will automatically complete your purchase with {merchant}.
              They will have up to 24 hrs to confirm your payment."
            values={{ merchant: props.merchantName }}
          />
        </h3>
        <p className="text-muted mt-4">
          {
            formatContentWithEmoji(
              <FormattedMessage
                id="autoPilot.on.confirmation"
                defaultMessage="You will receive a final confirmation or
                  notification of any issues via email."
              />,
              '📬',
            )
          }
        </p>
      </div>
      <div className="modal-section divider py-5 mb-4">
        <p>
          <FormattedMessage
            id="autoPilot.on.smootOperator"
            defaultMessage="Using auto-pilot makes you one smooth operator.
              You're the coolest organizer we know"
          />
          {' '}
          <span role="img" aria-label="">😎</span>
        </p>
      </div>
      <button
        className="btn btn-primary pull-right"
        type="button"
        onClick={props.onCloseClick}
      >
        <FormattedMessage
          id="autoPilot.on.button"
          defaultMessage="Cool!"
        />
      </button>
    </div>
  );
};

AutoPilotOn.defaultProps = {
  onCloseClick: () => {},
  merchantName: '[Merchant Name]',
};

export default AutoPilotOn;



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-dashboard/autopilot/autopilot.on.js